import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PrivacyPolicy } from './PrivacyPolicy';
import { useLanguage } from '../i18n/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <footer className="bg-[#060e1a] border-t border-white/5 pt-16 pb-8" data-id="element-73" data-mp="36p6df098t0cq">
      <div className="max-w-7xl mx-auto px-6" data-id="element-74" data-mp="36nd5ziqt2c3o">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-75" data-mp="3uesczotj1hl9">
          {/* Brand */}
          <div data-id="element-76" data-mp="38za4uuqp54h">
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-77" data-mp="37o2ul235f8m">LKHV.eu</h3>
            <p className="text-white/50 text-sm leading-relaxed mb-6" data-id="element-78" data-mp="3leviv7odbqit">
              {t.footer.about}{' '}
              <a href="https://www.aviatickyklubtlustice.cz" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-[#38bdf8] transition-colors underline-offset-2 hover:underline" data-id="element-79" data-mp="3qcniknv98gxk">
                {t.footer.operator}
              </a>
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-80" data-mp="3gb8vx23kfcv2">
            <h4 className="text-white font-semibold mb-6" data-id="element-81" data-mp="3gbr0cm0dsxe2">
              {t.footer.quickLinks}
            </h4>
            <ul className="space-y-1.5" data-id="element-82" data-mp="3v9azhcaljycb">
              {[{
              label: t.footer.aboutLink,
              href: '#hero'
            }, {
              label: t.nav.services,
              href: '#services'
            }, {
              label: t.nav.events,
              href: '#events'
            }, {
              label: t.nav.pilots,
              href: '#pilot-info'
            }, {
              label: t.nav.briefing,
              href: '/briefing',
              isRoute: true
            }, {
              label: t.nav.contact,
              href: '#contact'
            }].map(item => <li key={item.label} data-id="element-83" data-mp="twxsjd47hgaw">
                  {'isRoute' in item && item.isRoute ? <Link to={item.href} className="text-white/50 hover:text-[#38bdf8] text-sm transition-colors" data-id="element-84" data-mp="yuh60at2xp1s">
                      {item.label}
                    </Link> : <a href={item.href} className="text-white/50 hover:text-[#38bdf8] text-sm transition-colors" data-id="element-85" data-mp="1ckknypkxewlf">
                      {item.label}
                    </a>}
                </li>)}
            </ul>
          </div>

          {/* Contact Summary */}
          <div data-id="element-86" data-mp="3ob53vv65on1f">
            <h4 className="text-white font-semibold mb-6" data-id="element-87" data-mp="3obexrtubnece">
              {t.contact.title}
            </h4>
            <ul className="space-y-3 text-sm text-white/50" data-id="element-88" data-mp="3t9q805oj3qv5">
              <li data-id="element-89" data-mp="3tc2wz2spf1hp">
                <a href="https://aviatickyklubtlustice.cz/" target="_blank" rel="noopener noreferrer" className="hover:text-[#38bdf8] transition-colors" data-id="element-90" data-mp="2aevepuz5zs6u">
                  Aviatický klub Tlustice, z.s.
                </a>
              </li>
              <li data-id="element-91" data-mp="1woryplqvoupu">č.p. 258, 268 01 Tlustice</li>
              <li data-id="element-92" data-mp="1wlvz7szdtxza">+420 606 730 374</li>
              <li data-id="element-93" data-mp="2te9cyp3xfp35">info@aviatickyklubtlustice.cz</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-94" data-mp="2pbuqzw4yo97n">
          <p className="text-white/30 text-xs" data-id="element-95" data-mp="2kc8ig002vh56">{t.footer.rights}</p>
          <div className="flex space-x-6 text-xs text-white/30" data-id="element-96" data-mp="2fegnex44zewr">
            <button onClick={() => setShowPrivacy(true)} className="hover:text-white transition-colors cursor-pointer" data-id="element-97" data-mp="2fgb0xqd2w4qt">
              {t.footer.privacy}
            </button>
          </div>
        </div>
      </div>

      <PrivacyPolicy isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} data-id="element-98" data-mp="2rvhjbwxt0rca" />
    </footer>;
}